import { render, staticRenderFns } from "./CondoDetails.vue?vue&type=template&id=10a7f74c&"
import script from "./CondoDetails.vue?vue&type=script&lang=js&"
export * from "./CondoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10a7f74c')) {
      api.createRecord('10a7f74c', component.options)
    } else {
      api.reload('10a7f74c', component.options)
    }
    module.hot.accept("./CondoDetails.vue?vue&type=template&id=10a7f74c&", function () {
      api.rerender('10a7f74c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/CondoDetails.vue"
export default component.exports